import DapDSCalendar from './calendar.component'

export * from './calendar.component'
export default DapDSCalendar

DapDSCalendar.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-calendar': DapDSCalendar
  }
}
